<template>
    <div class="report" ref="imageWrapper">
        <header>
            <div class="back_btn" @click="$router.go(-1)" v-if="hide">
                <img src="@/assets/back.png">
            </div>
            <b>生物反馈报告</b>
            <p>{{biofeedbackResult.testReport}}</p>
            <div class="export" @click="Clickexport()" v-if="hide">
                <img src="@/assets/export.png" alt="导出图片">
            </div>
        </header>
        <main>
            <div class="item">
                <p class="title">一、个人基本信息</p>
                <el-descriptions class="iteminfo" :column="3" border>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">学号</template>{{biofeedbackResult.userId}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">姓名</template>{{biofeedbackResult.realName}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">性别</template>{{biofeedbackResult.sex}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">出生日期</template>{{biofeedbackResult.birthday}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">入学年份</template>{{biofeedbackResult.entryDate}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">学历</template>{{biofeedbackResult.degree}}</el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="item">
                <p class="title">二、测试概况</p>
                <el-descriptions class="iteminfo" :column="3" border>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">训练项目</template>{{biofeedbackResult.publishSubject}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">测试日期</template>{{biofeedbackResult.testTime}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">开始时间</template>{{biofeedbackResult.startTime}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">结束时间</template>{{biofeedbackResult.endTime}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">训练时长</template>{{biofeedbackResult.trainTime}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">训练详情</template>{{biofeedbackResult.testReport}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">训练类型</template>{{biofeedbackResult.testType}}</el-descriptions-item>
                    <el-descriptions-item label-class-name="labelName"><template slot="label">素材名称</template>{{biofeedbackResult.resultDetail}}</el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="item">
                <p class="title">三、HRV反馈数据</p>
                <div class="other">
                    <b>(1)生理数据</b>
                    <div class="table">
                        <p class="tabletitle"><span>指标</span><span>值</span></p>
                        <p><span>平均血氧</span><span>{{biofeedbackResult.physiologicalData.spO2}}</span></p>
                        <p><span>最大血氧</span><span>{{biofeedbackResult.physiologicalData.maxSpO2}}</span></p>
                        <p><span>呼吸频率</span><span>{{biofeedbackResult.physiologicalData.breathRate}}</span></p>
                        <p><span>吸气时间</span><span>{{biofeedbackResult.physiologicalData.isec}}</span></p>
                        <p><span>呼气时间</span><span>{{biofeedbackResult.physiologicalData.esec}}</span></p>
                        <p><span>呼吸比(I:E)</span><span>{{biofeedbackResult.physiologicalData.ieratio}}</span></p>
                    </div>
                </div>
                <div class="other" style="margin-bottom: 30px;">
                    <b>（2）时域分析数据</b>
                    <div class="table">
                        <p class="tabletitle"><span>指标</span><span>值</span></p>
                        <p><span>平均心率 M-HRT</span><span>{{biofeedbackResult.timeDomainAnalysisData.heartRate}}</span></p>
                        <p><span>最大心率 M-HRT</span><span>{{biofeedbackResult.timeDomainAnalysisData.maxRealTimeHeartRate}}</span></p>
                        <p><span>心率标准差 SD-HRT</span><span>{{biofeedbackResult.timeDomainAnalysisData.sdsd}}</span></p>
                        <p><span>心率变异系数 CV</span><span>{{biofeedbackResult.timeDomainAnalysisData.rrCv}}</span></p>
                        <p><span>心率变异均值 M-NN</span><span>{{biofeedbackResult.timeDomainAnalysisData.rrMean}}</span></p>
                        <p><span>心率变异极差 DRR</span><span>{{biofeedbackResult.timeDomainAnalysisData.drr}}</span></p>
                        <p><span>连续性差异平方根 RMSSD</span><span>{{biofeedbackResult.timeDomainAnalysisData.rmssd}}</span></p>
                        <p><span>连续性差异标准差 SDSD</span><span>{{biofeedbackResult.timeDomainAnalysisData.sdsd}}</span></p>
                        <p><span>连续性差异大于50ms  PNN50</span><span>{{biofeedbackResult.timeDomainAnalysisData.pnn50}}</span></p>
                        <p><span>连续性差异大于50ms 占比PNN50%</span><span>{{biofeedbackResult.timeDomainAnalysisData.pnn50Per}}</span></p>
                    </div>
                </div>
            </div>

            <div class="item" style="margin-bottom: 40px;">
                <p class="title">四、血氧</p>
                <div class="condition">
                    <b>血氧 {{biofeedbackResult.physiologicalData.spO2}}%</b>
                    <img src="../../assets/Analysissoftware/position.png" class="position"
                    :style="{'left':biofeedbackResult.physiologicalData.spO2<70?'0':biofeedbackResult.physiologicalData.spO2>100?'93%':((biofeedbackResult.physiologicalData.spO2-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.physiologicalData.spO2-70)/30).toFixed(2)*100+'%'}">
                    <div class="proportion">
                        <span class="color1"></span>
                        <span class="color2"></span>
                        <span class="color3"></span>
                        <span class="color4"></span>
                    </div>
                    <div class="proportiontext">
                        <div>
                            <label>70</label>
                            严重低氧血症
                        </div>
                        <div>
                            <label>91</label>
                            低氧血症</div>
                        <div>
                            <label>94</label>
                            良好
                        </div>
                        <div>
                            <label>95</label>
                            正常
                            <label class="last">100</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="item">
                <p class="title">五、HRV反馈结果图形解释</p>
                <p class="subhead">(1) 身心反馈状况图</p>
                <div class="conditionlist">
                    <div class="condition">
                        <b>抗压能力 {{biofeedbackResult.feedbackDiagramData.pressResist}}%</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position"
                        :style="{'left':biofeedbackResult.feedbackDiagramData.pressResist<70?'0':biofeedbackResult.feedbackDiagramData.pressResist>100?'93%':((biofeedbackResult.feedbackDiagramData.pressResist-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.pressResist-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                            <span class="color4"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                较弱
                            </div>
                            <div>
                                <label>91</label>
                                正常
                            </div>
                            <div>
                                <label>94</label>
                                较强
                            </div>
                            <div>
                                <label>95</label>
                                很强
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>

                    <div class="condition">
                        <b>精神压力 {{biofeedbackResult.feedbackDiagramData.pressMind}}</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position"
                        :style="{'left':biofeedbackResult.feedbackDiagramData.pressMind<70?'0':biofeedbackResult.feedbackDiagramData.pressMind>100?'93%':((biofeedbackResult.feedbackDiagramData.pressMind-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.pressMind-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                            <span class="color4"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                重度
                            </div>
                            <div>
                                <label>91</label>
                                较重
                            </div>
                            <div>
                                <label>94</label>
                                正常
                            </div>
                            <div>
                                <label>95</label>
                                较小
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>

                    <div class="condition">
                        <b>情绪指数 {{biofeedbackResult.feedbackDiagramData.mindMood}}</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position"
                        :style="{'left':biofeedbackResult.feedbackDiagramData.mindMood<70?'0':biofeedbackResult.feedbackDiagramData.mindMood>100?'93%':((biofeedbackResult.feedbackDiagramData.mindMood-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.mindMood-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                低落
                            </div>
                            <div>
                                <label>91</label>
                                佳
                            </div>
                            <div>
                                <label>95</label>
                                兴奋
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>

                    <div class="condition">
                        <b>疲劳指数 {{biofeedbackResult.feedbackDiagramData.tired}}</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position"
                        :style="{'left':biofeedbackResult.feedbackDiagramData.tired<70?'0':biofeedbackResult.feedbackDiagramData.tired>100?'93%':((biofeedbackResult.feedbackDiagramData.tired-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.tired-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                            <span class="color4"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                重度
                            </div>
                            <div>
                                <label>91</label>
                                较重
                            </div>
                            <div>
                                <label>94</label>
                                正常
                            </div>
                            <div>
                                <label>95</label>
                                较弱
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>

                    <div class="condition">
                        <b>综合放松 {{biofeedbackResult.feedbackDiagramData.meditation}}</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position"
                        :style="{'left':biofeedbackResult.feedbackDiagramData.meditation<70?'0':biofeedbackResult.feedbackDiagramData.meditation>100?'93%':((biofeedbackResult.feedbackDiagramData.meditation-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.meditation-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                            <span class="color4"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                较差
                            </div>
                            <div>
                                <label>91</label>
                                正常
                            </div>
                            <div>
                                <label>94</label>
                                较好    
                            </div>
                            <div>
                                <label>95</label>
                                很好
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>

                    <div class="condition">
                        <b>身体协调性 {{biofeedbackResult.feedbackDiagramData.balanceScore}}</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position" 
                        :style="{'left':biofeedbackResult.feedbackDiagramData.balanceScore<70?'0':biofeedbackResult.feedbackDiagramData.balanceScore>100?'93%':((biofeedbackResult.feedbackDiagramData.balanceScore-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.balanceScore-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                不佳
                            </div>
                            <div>
                                <label>94</label>
                                比较好
                            </div>
                            <div>
                                <label>95</label>
                                非常好
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>

                    <div class="condition">
                        <b>心率状况 {{biofeedbackResult.feedbackDiagramData.heartRate}}</b>
                        <img src="../../assets/Analysissoftware/position.png" class="position" 
                        :style="{'left':biofeedbackResult.feedbackDiagramData.heartRate<70?'0':biofeedbackResult.feedbackDiagramData.heartRate>100?'93%':((biofeedbackResult.feedbackDiagramData.heartRate-70)/30).toFixed(2)*100>93?'93%':((biofeedbackResult.feedbackDiagramData.heartRate-70)/30).toFixed(2)*100+'%'}">
                        <div class="proportion">
                            <span class="color1"></span>
                            <span class="color2"></span>
                            <span class="color3"></span>
                        </div>
                        <div class="proportiontext">
                            <div>
                                <label>70</label>
                                过缓
                            </div>
                            <div>
                                <label>91</label>
                                正常
                            </div>
                            <div>
                                <label>95</label>
                                过速
                                <label class="last">100</label>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="subhead">（2）心率曲线图</p>
                <div class="graphical">
                    <span class="graphicaltitle">心率(次/分)</span>
                    <div ref="heartrate" style="width:100%;height:260px;"></div>
                    <p class="text">时间(分钟)</p>
                    <div class="explain">
                        解释说明：是随着时间将瞬时心率描计而得的连续曲线图，横坐标为时间，纵坐标为由心搏间期计算得来的瞬时心率。是反映心率变异程度最常用的图表之一。心率变异性较大时，曲线波动性较大，复杂性更高；反之曲线相对平缓，更趋于直线。
                    </div>
                </div>

                <p class="subhead">（3）自主神经系统活动频谱图</p>
                <div class="graphical">
                    <div ref="diagram" style="width:100%;height:430px;"></div>
                </div>

                <p class="subhead">（4）呼吸采样图</p>
                <div class="graphical">
                    <span class="graphicaltitle">bmp</span>
                    <div ref="sampling" style="width:100%;height:430px;"></div>
                    <p class="text">时间(分钟)</p>
                </div>

                <p class="subhead">（5）HRV直方图</p>
                <div class="graphical">
                    <div ref="HRV" style="width:100%;height:430px;"></div>
                    <p class="text">RR间期(毫秒)</p>
                    <div class="explain">
                        解释说明<br/>   
                        &nbsp;&nbsp;&nbsp;&nbsp;是检测期间，心博间隔时间频次分布图。从400ms到1000ms之间，如果都集中在同一时间间隔上，说明心博变化很简单；如果400ms到1000ms之间，有多个分布时间间隔段，说明心博变化复杂。 <br/>        
                        &nbsp;&nbsp;&nbsp;&nbsp;直方图中小山峰的形状是底部宽平兼峰高矮小，反映变异性大，人处于健康状态；小山峰形状是底部窄兼峰高尖锐，反映变异性越小，处于不健康状态。
                    </div>
                </div>

                <p class="subhead">（6）RR间期散点图</p>
                <div class="graphical Scatterplotgraphical">
                    <span class="graphicaltitle">RR间期(毫秒)</span>
                    <div ref="Scatterplot" style="width:400px;height:260px;min-width: 400px;"></div>
                    <p class="text Scatterplottext">RR间期(毫秒)</p>
                    <div class="explain Scatterplotplain">
                        解释说明<br/>
                        是以依次发生的2个心博间隔时间为X轴、Y轴，如果每次心博间隔时间都相同，X＝Y，那么散点就集中在45°直线的范围上，说明心率变异叫小；反之散点分布范围广，心率变异大。<br/>    
                         整个点状图广而散地分布域一定范围内（散开未成直线状），反映人的心率变异性大；点状图的分布聚集于一处（处于45度角直线周围），反映人的心率变异性小。
                    </div>
                </div>
            </div>

            <div class="item">
                <p class="title">七、生物反馈结果</p>
                <div class="result" v-html="biofeedbackResult.resultDetail"></div>
            </div>

            <div class="item">
                <p class="title">八、综合评论</p>
                <el-form class="Reviews" label-width="150px" label-position="right">
                    <el-form-item label="心率状况">{{biofeedbackResult.feedbackDiagramData.heartRate}}</el-form-item>
                    <el-form-item label="抗压能力">{{biofeedbackResult.feedbackDiagramData.pressResist}}</el-form-item>
                    <el-form-item label="情绪指数">{{biofeedbackResult.feedbackDiagramData.mindMood}}</el-form-item>
                    <el-form-item label="协调状态">{{biofeedbackResult.feedbackDiagramData.coordinate}}</el-form-item>
                    <el-form-item label="皮电">{{biofeedbackResult.feedbackDiagramData.gsr}}</el-form-item>
                </el-form>
            </div>

        </main>
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
export default{
    name:'report',
    components: { html2canvas },
    data() {
        return {
            biofeedbackId:this.$route.query.biofeedbackId,
            hide:true,
            biofeedbackResult:{
                physiologicalData:{},
                feedbackDiagramData:{},
                timeDomainAnalysisData:{}
            },
        }
    },
    created(){
        this.GetDetail();
    },
    mounted() {
        
    },
    methods: {
        // 获取详细信息
        GetDetail(){
            this.$Http_Get('bioassay/biofeedbackResult/'+this.biofeedbackId).then(res=>{
                if(res.Code==0){
                    this.biofeedbackResult=res.Data;
                    this.heartrate(res.Data.feedbackDiagramData.heartRateCurve);
                    this.sampling(res.Data.feedbackDiagramData.respiratorySampling)
                    this.diagram(res.Data.feedbackDiagramData.autonomicNerve);
                    this.HRV(res.Data.feedbackDiagramData.rrIntervalScatter);
                    this.Scatterplot(res.Data.feedbackDiagramData.rrIntervalScatter)
                    console.log(res)
                }else{
                    this.$message({ message: res.Message, type: 'error'});
                }
            });
        },
        // 导出报告
        Clickexport(){
            var _this=this;
            this.hide=false;
            const loading =this.$loading({
                lock: true,
                text: '报告导出中···',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(function(){
                html2canvas(_this.$refs.imageWrapper,{dpi: 300,scale:2}).then(canvas => {
                    _this.isShowScroll = true;
                const link = document.createElement('a')
                link.href = canvas.toDataURL()
                link.setAttribute('download', _this.$t('report.question_tip8') + '.jpg')
                link.style.display = 'none'
                document.body.appendChild(link);
                link.click()
                _this.hide=true;
                loading.close();
            })
            },500);
            
        },
        // 心率曲线图
        heartrate(data){
            var second=[];
            for(let item in data){
                second.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.heartrate);
            var option={
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:10,
                    left: 120,  
                    right: 30,
                    bottom:30
                }, 
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data:second,
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    }
                },
                yAxis: {
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    }  
                },
                series: [
                    {
                    name: '心率值',
                    type: 'line',
                    data: data,
                    color: '#266300'  
                    },
                ]
            }
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 自主神经系统活动频谱图
        diagram(data) {
            var myChart = this.$echarts.init(this.$refs.diagram);
            var option={
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:10,
                    left: 120,  
                    right: 30,
                    bottom:60
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data:data.powerX,
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    },
                    axisLabel: {  
                        interval: 0,  // 标签间隔为0，即每个标签都显示  
  
                    },
                },
                yAxis: {
                    splitLine: {  
                        show: true,  
                    }  
                },
                visualMap: {
                    type: 'piecewise',
                    show: false,
                    dimension: 0,
                    pieces: [{
                        gt: 0,
                        lt: 99,
                        color: 'blue'
                    },{
                        gt: 100,
                        lt: 279,
                        color: 'yellow'
                    },{
                        gt: 280,
                        lt: 512,
                        color: 'red'
                    }]
                },
                dataZoom: [
                    {
                    type: 'inside',
                    start: 0,
                    end: 1
                    },{
                    start: 0,
                    end: 1
                    }
                ],
                series: [
                    {
                    name: '频谱',
                    type: 'line',
                    areaStyle: { },
                    data: data.powerY,
                    },
                ]
            }
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },

        // 呼吸采样图
        sampling(data){
            var second=[];
            for(let item in data){
                second.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.sampling);
            var option={
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:10,
                    left: 120,  
                    right: 30,
                    bottom:30
                }, 
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data:second,
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    }
                },
                yAxis: {
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    }  
                },
                series: [
                    {
                    name: '心率值',
                    type: 'line',
                    data: data,
                    color: '#266300'  
                    },
                ]
            }
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },

        // HRV直方图
        HRV(data){
            var second=[];
            for(let item in data){
                second.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.HRV);
            var option={
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:10,
                    left: 120,  
                    right: 30,
                    bottom:30
                }, 
                xAxis: {
                    type: 'category',
                    data:second,
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    },
                    axisLabel: {  
                        interval: 50, // 每隔两个标签显示一个  
                    }
                },
                yAxis: {
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    }  
                },
                series: [
                    {
                    name: '心率值',
                    type: 'bar',
                    data: data,
                    color: '#266300'  
                    },
                ]
            }
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },

        // 散点图
        Scatterplot(data){
            var second=[];
            for(let item in data){
                second.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.Scatterplot);
            var option={
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top:10,
                    left: 120,  
                    right: 30,
                    bottom:30
                }, 
                xAxis: {
                    type: 'category',
                    data:second,
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    },
                    axisLabel: {  
                        interval: 50, // 每隔两个标签显示一个  
                    }
                },
                yAxis: {
                    splitLine: {  
                        show: true,  
                        lineStyle: {  
                            color: '#E3E3E3', // 分割线颜色  
                            width: 1, // 分割线宽度  
                            type: 'solid' // 分割线类型  
                        }    
                    }  
                },
                series: 
                [
                    {


                        type: 'scatter',
                        data: data,
                        color: '#266300'  
                    },
                ]
            }
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
    },
}
</script>
<style>
.report{background:url('../../assets/Analysissoftware/report_bg.png') repeat #CBE3BC center;min-height: 100%;background-size: 230px;padding-bottom: 60px;}
.report header{background: linear-gradient(180deg, #507D38 0%, #CBE3BC 100%);padding: 24px 0 40px;text-align: center;}
.report header .back_btn{position: absolute;top: 30px;left: 30px;width: 40px;}
.report header .export{position: absolute;top: 30px;right: 30px;width: 40px;}
.report header b{font-size: 40px;color: #fff;text-shadow:0px 1px 10px #476635;}
.report header p{font-size: 20px;color: #476635;text-shadow:0 0 5px #fff;font-weight: bold;}
/* .report main .item{} */
.report main .item .title{font-size: 28px;background: linear-gradient(270deg,rgb(255 255 255 /0) 0%, rgb(255 255 255 / 50%) 100%);padding: 10px 40px;font-weight: bold;}
.report main .item .iteminfo{margin:30px 40px;}
.report main .item .iteminfo .labelName{background: #557046;color:#fff;font-size: 22px;text-align: right;border: 1px solid #466635;width: 150px;}
.report main .el-descriptions .is-bordered .el-descriptions-item__cell{border:1px solid #466635;font-size: 22px;}
.report main .el-descriptions-item__content{width: 20%;}
.report main .item .other{margin:0 40px 0;}
.report main .item .other b{font-size: 24px;color: #557046;margin: 20px 0;display: block;}
.report main .item .other .table{background: #fff;border-left: 1px solid #466635;border-right: 1px solid #466635;}
.report main .item .other .table p{font-size: 20px;color: #1C3D09;display: flex;border-bottom: 1px solid #1C3D09;}
.report main .item .other .table p span{border-right: 1px solid #466635;flex: 1;padding: 10px 30px;text-align: right;}
.report main .item .other .table p span:last-child{border:none;text-align: left;}
.report main .item .other .table p.tabletitle{font-size: 22px;background: #557046;color: #fff;}
.report main .item .other .table p.tabletitle span{text-align: center;font-weight: bold;}
.report main .item .condition{background: #fff;padding: 14px;border: 1px solid #466635;max-width: 590px;margin:30px 40px 0;position: relative;width: 40%;}
.report main .item .condition b{font-size: 24px;color: #438F00;padding-bottom: 10px;text-align: center;display: block;}
.report main .item .condition .proportion{display: flex;border-radius: 200px;height: 32px;margin-bottom: 10px;overflow: hidden;}
.report main .item .condition .proportiontext{display: flex;}
.report main .item .condition .proportion span,.report main .item .condition .proportiontext div{flex: 1;height: 100%;text-align: center;color: #1C3D09;}
.report main .item .condition .proportiontext div label{float: left;}
.report main .item .condition .proportiontext div label.last{float:right;}
.report main .item .condition .position{flex: none;position: absolute;top:40px;left:10px;width:30px;}
.report main .item .subhead{font-size: 22px;color: #557046;padding: 20px 40px 0;}
.report main .item .graphical{background: #fff;border: 1px solid #557046;margin: 30px 44px;padding: 30px 0;position: relative;}
.report main .item .graphical .graphicaltitle{position: absolute;top: 40px;left: 60px;color: #153B00;font-size: 16px;writing-mode: vertical-lr;text-orientation: sideways;}
.report main .item .graphical .text{text-align: center;color: #153B00;}
.report main .item .Scatterplotgraphical{display: flex;padding: 30px 0 60px;}
.report main .item .graphical .Scatterplottext{position: absolute;bottom: 30px;left: 200px;}
.report main .item .graphical .Scatterplotplain{line-height:2;font-size: 12px;}
.report main .item .graphical .explain{font-size: 14px;padding: 0 40px;}
.report main .item .conditionlist{display: flex;flex-wrap: wrap;margin-bottom: 10px;}
.report main .item .result{background: #fff;border: 1px solid #557046;min-height: 188px;margin:30px 40px;}
.report main .item .Reviews{margin: 30px 44px;}
.report main .item .Reviews .el-form-item{font-size: 22px;margin:0 0 16px;border: 1px solid #466635;background: #fff;}
.report main .item .Reviews .el-form-item__label{background:#557046;color: #fff;margin-right: 15px;}
.color1{background: #A31D1D;}
.color2{background: #66A340;}
.color3{background: #3F7A1A;}
.color4{background: #1E4208;}
.color5{background: #B35A1B;}
.color6{background: #D62222;}
</style>